// src/store/modules/rangeBoxGeneral/index.js
import * as actions from "./actions";

const state = {};

export default {
  namespaced: true,
  state,
  actions,
  mutations: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/rangeBoxGeneral/index.js